import axios from "axios";
import {
  Branch_Contact_URL,
  Branch_Location_Pincode_URL,
  System_URL,
} from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

// Start GET call for branch location

export const getBranchLocationActions = {
  GET_BRANCH_LOCATION_DETAIL_SUCCESS: "GET_BRANCH_LOCATION_DETAIL_SUCCESS",
  GET_BRANCH_LOCATION_DETAIL_ERROR: "GET_BRANCH_LOCATION_DETAIL_ERROR",
};

export function getBranchLocationDetail(props) {
  const { accessToken, partnerFirmId, partnerBranchId } = props;

  // const accessToken = props
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Branch_Contact_URL}/getPartnerBranchLocation?partnerBranchId=${partnerBranchId}&partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getbranchLocationSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        }
        // else if (response.status === 403) {
        //   const error = new Error(response.statusText);
        //   dispatch(clearLogoutData());
        //   // dispatch(firmDetailMasterError(error))

        //   // return response;
        //   throw error;
        // }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function getbranchLocationError(error) {
  return {
    type: getBranchLocationActions.GET_BRANCH_LOCATION_DETAIL_ERROR,
    payload: error,
  };
}

export function getbranchLocationSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationActions.GET_BRANCH_LOCATION_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

//End GET call for branch location

export const branchLocationActions = {
  FETCH_BRANCH_LOCATION_LIST: "FETCH_BRANCH_LOCATION_LIST",
  FETCH_BRANCH_LOCATION_LIST_SUCCESS: "FETCH_BRANCH_LOCATION_LIST_SUCCESS",
  FETCH_BRANCH_LOCATION_LIST_ERROR: "FETCH_BRANCH_LOCATION_LIST_ERROR",
};

export function saveBranchLocationDetails(props) {
  const { access_token, partnerFirmId, newValues } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Contact_URL}/savePartnerBranchLocation?partnerFirmId=${partnerFirmId}`,
      data: newValues,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          getBranchLocationDetailsError(err);

          return err;
        }
      });
}
export function getBranchLocationDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: branchLocationActions.FETCH_BRANCH_LOCATION_LIST_SUCCESS,
      payload: props,
    });
  };
}
export function getBranchLocationDetailsError(error) {
  return {
    type: branchLocationActions.FETCH_BRANCH_LOCATION_LIST_ERROR,
    payload: error,
  };
}

export const pincodeListActions = {
  PINCODE_LIST: "PINCODE_LIST",
  PINCODE_LIST_SUCCESS: "PINCODE_LIST_SUCCESS",
  PINCODE_LIST_ERROR: "PINCODE_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getPincodeOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${Branch_Location_Pincode_URL}/search/Pincode?pincode=` + inputValue,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPincodeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPincodeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPincodeListError(err));
          return err.response;
        }
      });
}

export function getPincodeListRequest() {
  return {
    type: pincodeListActions.PINCODE_LIST,
    isPosting: true,
  };
}
export function getPincodeListError(error) {
  return {
    type: pincodeListActions.PINCODE_LIST_ERROR,
    payload: error,
  };
}

export function getPincodeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pincodeListActions.PINCODE_LIST_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByPincodeActions = {
  GET_BRANCH_LOCATION_BY_PINCODE: "GET_BRANCH_LOCATION_BY_PINCODE",
  GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS:
    "GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS",
  GET_BRANCH_LOCATION_BY_PINCODE_ERROR: "GET_BRANCH_LOCATION_BY_PINCODE_ERROR",
  LOGOUT: "LOGOUT",
};

export function getBranchLocationByPincode(props) {
  const { access_token, url, data, pincode } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincodeId=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByPincodeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByPincodeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByPincodeError(err));
          return err.response;
        }
      });
}

export function getBranchLocationByPincodeRequest() {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE,
    isPosting: true,
  };
}
export function getBranchLocationByPincodeError(error) {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_ERROR,
    payload: error,
  };
}

export function getBranchLocationByPincodeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByAreaActions = {
  GET_BRANCH_LOCATION_BY_AREA: "GET_BRANCH_LOCATION_BY_AREA",
  GET_BRANCH_LOCATION_BY_AREA_SUCCESS: "GET_BRANCH_LOCATION_BY_AREA_SUCCESS",
  GET_BRANCH_LOCATION_BY_AREA_ERROR: "GET_BRANCH_LOCATION_BY_AREA_ERROR",
  LOGOUT: "LOGOUT",
};
export function getBranchLocationByArea(props) {
  const { access_token, url, pincode, data } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincode=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByAreaSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByAreaError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByAreaError(err));
          return err.response;
        }
      });
}

export function getLocMasterByAreaRequest() {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA,
    isPosting: true,
  };
}
export function getBranchLocationByAreaError(error) {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_ERROR,
    payload: error,
  };
}

export function getBranchLocationByAreaSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_SUCCESS,
      payload: props,
    });
  };
}

export const SVMListActions = {
  SVM_LIST: "SVM_LIST",
  SVM_LIST_SUCCESS: "SVM_LIST_SUCCESS",
  SVM_LIST_ERROR: "SVM_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getSVMList(props) {
  const { access_token, name, url } = props;
  let endpoint = "";
  if (url) {
    endpoint = `${System_URL}/get/${url}/${name}`;
  } else {
    endpoint = `${System_URL}/listing/SystemValueMasters`;
  }
  // if(url){
  //       endpoint = `${System_URL}/listing/SystemValueMasters`;
  // }
  return (dispatch) =>
    axios({
      method: "get",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: endpoint,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getSVMListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getSVMListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getSVMListError(err));
          return err.response;
        }
      });
}

export function getSVMListRequest() {
  return {
    type: SVMListActions.SVM_LIST,
    isPosting: true,
  };
}
export function getSVMListError(error) {
  return {
    type: SVMListActions.SVM_LIST_ERROR,
    payload: error,
  };
}

export function getSVMListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SVMListActions.SVM_LIST_SUCCESS,
      payload: props,
    });
  };
}
